import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';

const CustomToast = ({ text, icon, duration = 3, visible, onHide }) => {
  const [opacity, setOpacity] = useState(0);
  const onHideRef = useRef(onHide);

  // Keep onHide ref updated
  useEffect(() => {
    onHideRef.current = onHide;
  }, [onHide]);

  useEffect(() => {
    if (visible) {
      // Fast fade in
      setOpacity(1);

      // Set timeout for fade out
      const hideTimer = setTimeout(() => {
        setOpacity(0);
        // Call onHide after fade out animation completes
        setTimeout(() => {
          if (onHideRef.current) onHideRef.current();
        }, 200);
      }, duration * 1000);

      return () => clearTimeout(hideTimer);
    } else {
      setOpacity(0);
    }
  }, [visible, duration]);

  if (!visible && opacity === 0) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 9999,
        pointerEvents: 'none',
      }}
    >
      <Box
        sx={{
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          border: '2px solid rgba(255, 255, 255, 0.9)',
          borderRadius: '12px',
          padding: '16px 32px',
          minWidth: '280px',
          maxWidth: '90vw',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(8px)',
          opacity: opacity,
          transition: 'opacity 0.2s ease-in-out',
        }}
      >
        {icon && (
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1, color: 'white', '& .MuiSvgIcon-root': { fontSize: '2rem' } }}>
            {icon}
          </Box>
        )}
        <Typography
          sx={{
            color: 'white',
            fontSize: '1rem',
            fontWeight: 500,
            textAlign: 'center',
            whiteSpace: 'pre-line',
            letterSpacing: '0.02em',
          }}
        >
          {text}
        </Typography>
      </Box>
    </Box>
  );
};

export default CustomToast;
